import Model from './Model'

export default class QuestionModel extends Model {
  public id: number|undefined

  resource () : string {
    return 'questions'
  }
}
